module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_xtrh_two.6a28bbfa.png";